import { Link } from "react-router-dom";
import { animeList, formatViews } from "@/mocks/anime";

const ranked = [...animeList].sort((a, b) => b.views - a.views).slice(0, 8);

export default function HotRanking() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14" aria-labelledby="ranking-title">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
        <div className="lg:col-span-2">
          <div className="flex items-end justify-between gap-4 mb-6">
            <div>
              <p className="text-[11px] font-bold tracking-[0.2em] text-accent-600 mb-2">RANKING</p>
              <h2 id="ranking-title" className="text-xl md:text-2xl font-black text-foreground-950 tracking-tight">
                热门动漫推荐榜单
              </h2>
              <p className="mt-2 text-[13px] text-foreground-600">按播放热度实时排序（演示数据）</p>
            </div>
            <Link
              to="/category/riman"
              className="hidden sm:inline-flex items-center gap-1 text-[13px] font-medium text-primary-700 hover:text-primary-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              全部榜单 <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <ol className="bg-background-100 border border-background-200 rounded-lg overflow-hidden divide-y divide-background-200">
            {ranked.map((anime, i) => (
              <li key={anime.id}>
                <Link
                  to={`/detail/${anime.id}`}
                  className="group flex items-center gap-3 md:gap-4 px-3 md:px-4 py-3 hover:bg-background-50 transition-colors cursor-pointer"
                >
                  <span
                    className={`w-7 h-7 rounded-md flex items-center justify-center text-[13px] font-black shrink-0 ${
                      i < 3 ? "bg-accent-500 text-primary-950" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {i + 1}
                  </span>
                  <div className="w-12 h-16 md:w-14 md:h-[74px] rounded-md overflow-hidden shrink-0 bg-background-200">
                    <img
                      src={anime.cover}
                      alt={`${anime.title}封面缩略图`}
                      title={`${anime.title} - 热门动漫榜单`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-[14px] font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-700 transition-colors">
                      {anime.title}
                    </h3>
                    <p className="mt-1 text-[12px] text-foreground-500 line-clamp-1">
                      {anime.type} · {anime.region} · {anime.year}
                    </p>
                    <div className="mt-1.5 flex items-center gap-3 text-[11px] text-foreground-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-play-circle-line" />
                        {formatViews(anime.views)}
                      </span>
                      <span className="flex items-center gap-1 text-accent-700 font-semibold">
                        <i className="ri-star-fill text-[10px]" />
                        {anime.rating.toFixed(1)}
                      </span>
                    </div>
                  </div>
                  <span className="hidden sm:inline-flex px-2 py-0.5 rounded bg-secondary-100 text-secondary-900 text-[11px] font-medium shrink-0">
                    {anime.status}
                  </span>
                  <i className="ri-arrow-right-s-line text-foreground-400 text-lg shrink-0" />
                </Link>
              </li>
            ))}
          </ol>
        </div>

        <aside className="lg:col-span-1">
          <div className="rounded-lg bg-primary-950 text-background-100 p-5 md:p-6 h-full flex flex-col">
            <p className="text-[11px] font-bold tracking-[0.2em] text-accent-400 mb-2">EDITOR'S PICK</p>
            <h3 className="text-lg font-black text-background-50 tracking-tight">编辑精选</h3>
            <p className="mt-2 text-[12px] leading-6 text-primary-200">
              本周我们挑了三部风格完全不同但都值得一看的作品，从热血机甲到深夜食堂。
            </p>
            <div className="mt-5 space-y-3 flex-1">
              {[animeList[4], animeList[6], animeList[1]].map((anime) => (
                <Link
                  key={anime.id}
                  to={`/detail/${anime.id}`}
                  className="flex gap-3 group cursor-pointer"
                >
                  <div className="w-14 h-20 rounded-md overflow-hidden shrink-0">
                    <img
                      src={anime.cover}
                      alt={`${anime.title}编辑推荐封面`}
                      title={`${anime.title} - 编辑精选推荐`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0 flex flex-col justify-center">
                    <p className="text-[13px] font-semibold text-background-50 line-clamp-1 group-hover:text-accent-300 transition-colors">
                      {anime.title}
                    </p>
                    <p className="mt-1 text-[11px] text-primary-300 line-clamp-2 leading-5">
                      {anime.summary}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
            <Link
              to="/news"
              className="mt-5 inline-flex items-center justify-center gap-1.5 h-10 rounded-md bg-accent-500 hover:bg-accent-600 text-primary-950 text-[13px] font-bold transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-newspaper-line" />
              看看本周资讯
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}